import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "background"]

  connect() {
    this.boundSetAspectClass = this.setAspectClass.bind(this)
    this.videoTarget.addEventListener("loadedmetadata", this.boundSetAspectClass)

    if (this.videoTarget.readyState >= 1) {
      this.setAspectClass()
    }
  }

  disconnect() {
    this.videoTarget.removeEventListener("loadedmetadata", this.boundSetAspectClass)
  }

  setAspectClass() {
    const video = this.videoTarget
    const w = video.videoWidth
    const h = video.videoHeight
    if (!w || !h) return

    const aspect = w / h
    if (aspect > 1) {
      this.element.classList.add("clip-video--wide")
      this.element.classList.remove("clip-video--tall")
    } else {
      this.element.classList.add("clip-video--tall")
      this.element.classList.remove("clip-video--wide")
    }
  }
}
